// extracted by mini-css-extract-plugin
export var hero = "Hero-module--hero--3uav6";
export var hero_wrapper = "Hero-module--hero_wrapper--2Vh9L";
export var flowers = "Hero-module--flowers--1AVvE";
export var content = "Hero-module--content--1QWME";
export var block = "Hero-module--block--37abN";